import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

import { SectionEditButton } from 'components/buttons'

import { ICVPreferencesProps } from './types'

const CVPreferences = ({
  bonuses,
  openToPartTime,
  editable,
  onEdit
}: ICVPreferencesProps) => {
  const { t } = useTranslation(['cv_modal'])

  const hasAnyPrefer = useMemo(
    () => bonuses.length || openToPartTime,
    [bonuses.length, openToPartTime]
  )

  return (
    <div className="pt-2">
      <div className="flex items-center justify-between">
        <h2 className="pb-6 text-2xl font-bold tracking-wide">
          {t('fields.preferences', { ns: 'cv_modal' })}
          <i className="dot"></i>
        </h2>
        {editable && <SectionEditButton onClick={() => onEdit?.(null)} />}
      </div>
      <div
        className={`flex flex-wrap gap-x-2 ${
          hasAnyPrefer ? 'gap-y-2' : ''
        } pb-10`}
      >
        {openToPartTime && (
          <span className="rounded-full border border-gray-300 px-4 py-2">
            <span className="text-md mr-2">⏲</span>
            {t('fields.prefPartTime', { ns: 'cv_modal' })}
          </span>
        )}

        {bonuses.map((bonus) => (
          <span
            key={bonus}
            className="rounded-full border border-gray-300 px-4 py-2"
          >
            {t(`fields.${bonus}`, { ns: 'cv_modal' })}
          </span>
        ))}
      </div>
    </div>
  )
}

export default CVPreferences
